import withContentfulData from 'components/hoc/withContentfulData';

import FaqCategory from './FaqCategory';

export default withContentfulData(FaqCategory);
